module.exports = __webpack_public_path__ + "media/process/Process3-45efd1d2.png";